import { IStatusModel /*, IStatusModel*/ } from '../models/statuses.model';
import * as StatusActions from './status.actions';
import { IAppState } from '../../store/app.state';
import { Action, createReducer, createSelector, on } from '@ngrx/store';

export type State = IStatusModel;

const initialState: State = {
  loadingStatuses: false,
  statusesList: null
};

const statusesReducer = createReducer(
  initialState,

  on(StatusActions.GetStatusesList, (): State => {
    return {
      statusesList: null,
      loadingStatuses: true
    };
  }),
  on(StatusActions.GetStatusesListSuccess, (_state, { payload }): State => {
    return {
      statusesList: payload.statuses.map((status) => ({
        ...status,
        created_at: new Date(status.created_at),
        updated_at: new Date(status.updated_at)
      })),
      loadingStatuses: false
    };
  }),
  on(StatusActions.GetStatusesListFailed, (): State => {
    return {
      statusesList: null,
      loadingStatuses: false
    };
  }),
  on(StatusActions.DeleteStatus, (state): State => {
    return {
      ...state,
      loadingStatuses: true
    };
  }),
  on(StatusActions.DeleteStatusSuccess, (state, { payload }): State => {
    return {
      statusesList: state.statusesList.filter((status) => status._id !== payload),
      loadingStatuses: false
    };
  }),
  on(StatusActions.DeleteStatusFailed, (state): State => {
    return {
      ...state,
      loadingStatuses: false
    };
  }),
  on(StatusActions.CreateStatus, (state): State => {
    return {
      ...state,
      loadingStatuses: true
    };
  }),
  on(StatusActions.CreateStatusSuccess, (state, { payload }): State => {
    return {
      loadingStatuses: false,
      statusesList: [payload, ...state.statusesList]
    };
  }),
  on(StatusActions.CreateStatusFailed, (state): State => {
    return {
      ...state,
      loadingStatuses: false
    };
  }),

  on(StatusActions.EditStatus, (state): State => {
    return {
      ...state,
      loadingStatuses: true
    };
  }),
  on(StatusActions.EditStatusSuccess, (state, { payload }): State => {
    return {
      loadingStatuses: false,
      statusesList: state.statusesList.map((status) => (status._id === payload._id ? payload : status))
    };
  }),
  on(StatusActions.EditStatusFailed, (state): State => {
    return {
      ...state,
      loadingStatuses: false
    };
  })
);

const statusesState = (state: IAppState) => state.statuses;

export const reducer = (state: State, action: Action): State => statusesReducer(state, action);

export const getStatusesList = createSelector(statusesState, (state: IStatusModel) => state.statusesList);

export const isLoadingStatuses = createSelector(statusesState, (state: IStatusModel) => state.loadingStatuses);
